import {computed} from 'mobx';

import {GameCompetitorDomainModel} from "./game-competitor-domain-model";
import {CompetitorViewModel} from "../../../common/competitor/models/competitor-view-model";
import {FoulsViewModel} from "../fouls/fouls.view-model";
import {RecordViewModel} from "../record/record.view-model";

export class GameCompetitorViewModel extends CompetitorViewModel {
  domainModel: GameCompetitorDomainModel;

  get objectType(): * {
    return CompetitorViewModel.name;
  }

  @computed get isQualified(): Boolean {
    return this.domainModel.isQualified;
  }

  @computed get toQualify(): Boolean {
    return this.domainModel.toQualify;
  }

  @computed get score(): String {
    return this.domainModel?.score === -1 ? '' : this.domainModel?.score?.toString();
  }

  @computed get redCards(): Number {
    return this.domainModel.redCards;
  }

  @computed get aggregatedScore(): String {
    return this.domainModel.aggregatedScore;
  }

  @computed get seriesScore(): Number {
    return this.domainModel.seriesScore;
  }

  @computed get isWinner(): Boolean {
    return this.domainModel.isWinner;
  }

  @computed get recentMatches(): Array<Number> {
    return this.domainModel.recentMatches;
  }

  @computed get fouls(): FoulsViewModel {
    const fouls = this.domainModel.fouls && new FoulsViewModel(this.domainModel.fouls);

    return fouls;
  }

  get record() {
    const record = this.domainModel.record && new RecordViewModel(this.domainModel.record);

    return record;
  }

  get recordWins(): Number {
    const wins = this.domainModel.record?.wins;

    return wins;
  }

  get recordLoses(): Number {
    const loses = this.domainModel.record?.loses;

    return loses;
  }

  get recordDraws(): Number {
    const draws = this.domainModel.record?.ties;

    return draws;
  }

  get recordLabel(): String {
    const wins: String = this?.recordWins !== undefined ? `${this?.recordWins}` : '';
    const losses: String = this?.recordLoses !== undefined ? `- ${this?.recordLoses}` : '';
    const draws: String = this?.recordDraws ? `- ${this?.recordDraws}` : '';
    const record: String = `${wins} ${losses} ${draws}`;

    return record;
  }

  get isShowRecord(): Boolean {
    const record: Boolean = this.recordLoses >= 0 && this.recordWins >= 0;

    return record;
  }

  get extraDataTitle(): String {
    return this.domainModel.extraDataTitle;
  }

  get symbolicName(): String {
    return this.domainModel.symbolicName;
  }
}
